var _rect, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductImageFallbackicon = function SvgProductImageFallbackicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#EEE",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A6A6",
    strokeWidth: 3,
    d: "M18.5 19.5h27v25h-27z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 27,
    r: 3,
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "m20 42 9-9 6 6 4-4 5 5v3H20z"
  })));
};
export default SvgProductImageFallbackicon;